import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "全部影视", to: "/category/all" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" }
];

const categoryLinks = [
  { label: "动漫", to: "/category/anime" },
  { label: "综艺", to: "/category/variety" },
  { label: "纪录片", to: "/category/documentary" },
  { label: "关于我们", to: "/about" }
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-primary-800 bg-primary-950">
      <div className="w-full px-4 pb-24 pt-12 md:px-6 lg:pb-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-accent-400">
                <i className="ri-movie-2-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-700 text-foreground-50">
                秘密影院
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              {siteInfo.slogan}
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-primary-900/60 px-3 py-1.5 text-xs text-accent-300">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-information-line" aria-hidden="true" />
              </span>
              内容演示平台 · 无真实播放与下载
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-600 text-foreground-100">
              快速导航
            </h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-600 text-foreground-100">
              内容分类
            </h4>
            <ul className="mt-4 space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-600 text-foreground-100">
              联系我们
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-secondary-400">
                  <i className="ri-mail-line" aria-hidden="true" />
                </span>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-secondary-400">
                  <i className="ri-time-line" aria-hidden="true" />
                </span>
                内容每日更新
              </li>
              <li>
                <Link
                  to="/about"
                  className="mt-2 inline-flex cursor-pointer items-center gap-1 text-accent-400 transition-colors hover:text-accent-300"
                >
                  前往反馈与留言
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-s-line" aria-hidden="true" />
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 秘密影院 · 保留所有权利</p>
          <p>本站为影视内容展示与推荐演示平台，所有影视信息均为演示数据。</p>
        </div>
      </div>
    </footer>
  );
}